import { render, staticRenderFns } from "./study.vue?vue&type=template&id=e0394718&scoped=true"
import script from "./study.vue?vue&type=script&lang=js"
export * from "./study.vue?vue&type=script&lang=js"
import style0 from "./study.vue?vue&type=style&index=0&id=e0394718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0394718",
  null
  
)

export default component.exports